import * as React from 'react';

import ManagerSegmentStore from './ManagerSegmentStore';
import {
  ManagerSegmentStoreContext,
  ManagerSegmentStoreProvider
} from './context';

const useManagerSegmentStore = (): ManagerSegmentStore => {
  const managerSegmentStoreContext = React.useContext(
    ManagerSegmentStoreContext
  );

  return managerSegmentStoreContext.store as ManagerSegmentStore;
};

export {
  ManagerSegmentStore,
  useManagerSegmentStore,
  ManagerSegmentStoreProvider
};
